import { Injectable } from '@angular/core';
import {Subject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class SceneListService {

    selectedChanged$ = new Subject();

    deleteSelected$ = new Subject();

    constructor() {
    }

    selectScenes(ids) {
        debugger;
        this.selectedChanged$.next(ids);

    }

    deleteSelected() {
        debugger;
        this.deleteSelected$.next("delete");
    }
}
